import { CATEGORY_PARAMETERS_SHOW_LIMIT } from '@/grandus-lib/constants/AppConstants';
import get from 'lodash/get';
import find from 'lodash/find';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import without from 'lodash/without';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getFilterUrl } from '@/utils/filter';
import isFunction from 'lodash/isFunction';
import CarretDownIcon from '@/components/_other/icons/CarretDownIcon';
import Image from 'grandus-utils/wrappers/image/Image';

const CheckboxElement = ({
  selected,
  parameterTitle,
  parameterValueTitle,
  parameterValueValue,
  parameterValue,
  handleGetData,
  parameter = false,
  parameterImages = [],
}) => {
  const [isActive, setIsActive] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setIsActive(includes(selected?.parameters?.[parameterTitle] ?? [], parameterValueTitle));
  }, [selected, parameterTitle, parameterValueTitle]);

  const url = isFunction(handleGetData)
    ? handleGetData(parameterTitle, parameterValueTitle, isActive)
    : getFilterUrl(
        selected,
        parameterTitle,
        parameterValueTitle,
        isActive,
      );

  const parameterId = parameter?.id;

  const parameterImage = find(parameterImages, {
    hash: `${parameterId}_${parameterValueValue}`,
  });

  return (
    <div className={'customCheckbox'}>
      <Link
        prefetch={false}
        href={url?.pathname ?? '#'}
        scroll={false}
        className={'absolute pointer-events-none'}
      ></Link>
      <label
        className={isActive ? 'active' : ''}
        onClick={() => {
          setIsActive(v => !v);
          router.push(url?.pathname, { scroll: false });
        }}
      >
        <span className="check"></span>
        <span className="label">
          {parameterImage?.photo ? (
            <span className="inline-block mr-2 align-middle">
              <Image
                photo={parameterImage.photo}
                width={30}
                height={30}
                type="png"
                alt={parameterValueValue}
              />
            </span>
          ) : (
            ''
          )}
          {parameterValueValue}
          {
            <small>
              <i> ({get(parameterValue, 'productCount', 0)})</i>
            </small>
          }
        </span>
      </label>
    </div>
  );
};

const CategoryElementCheckbox = props => {
  const {
    parameter,
    selected,
    options = {},
    setOpened,
    opened,
    category,
    search,
    handleGetData,
    parameterImages = []
  } = props;

  const {
    id: parameterId,
    name: parameterName,
    // urlTitle: parameterTitle,
  } = parameter;

  const [showAll, setShowAll] = useState(false);

  const parameterTitle = parameter?.urlTitle
    ? parameter?.urlTitle
    : parameter['v2-name'];

  const parameterSelected = get(selected, [parameterTitle], []);
  const parameterValues = get(parameter, 'values', []);

  const {
    styles = {},
    headline = '',
    showAllOverride = false,
    hideAll = false,
    openExclusive = false,
  } = options;

  const parametersShowLimit = hideAll ? 0 : CATEGORY_PARAMETERS_SHOW_LIMIT;

  useEffect(() => {
    if (includes(opened, parameterTitle)) {
      setShowAll(true);
    } else {
      setShowAll(false);
    }
    if (parameterValues.length < parameterSelected.length) {
      setShowAll(false);
    }
  }, [opened]);

  const handleParamClick = () => {
    if (!hideAll) {
      return;
    }
    if (showAll) {
      setShowAll(false);
      setOpened(without(opened, parameterTitle));
    } else {
      setShowAll(true);
      const openParameters = openExclusive
        ? [parameterTitle]
        : [...opened, parameterTitle];
      setOpened(openParameters);
    }
  };

  if (isEmpty(parameterValues)) {
    return '';
  }
  return (
    <>
      <div className={styles.item}>
        {headline ? (
          headline
        ) : (
          <div
            className={`${styles.header} ${hideAll ? styles.clickable : ''}`}
            onClick={handleParamClick}
          >
            <h3>{parameterName} </h3>
            {hideAll ? (
              <>
                {showAll ? (
                  <CarretDownIcon className={'rotate-180'} />
                ) : (
                  <CarretDownIcon />
                )}
              </>
            ) : (
              ''
            )}
          </div>
        )}

        {parameterValues.map((parameterValue, index) => {
          if (!showAllOverride) {
            if (!showAll && index >= parametersShowLimit) {
              return '';
            }
          }

          const parameterValueId = get(
            parameterValue,
            'id',
            encodeURIComponent(parameterValue?.value),
          );
          const parameterValueValue = get(
            parameterValue,
            'value',
            get(parameterValue, 'name'),
          );
          const parameterValueTitle = encodeURIComponent(
            get(
              parameterValue,
              'urlName',
              get(parameterValue, 'v2-value', parameterValueValue),
            ),
          );

          return (
            <CheckboxElement
              key={`category-${parameterId}-${parameterValueId}-${index}`}
              category={category}
              search={search}
              selected={selected}
              parameterValueTitle={parameterValueTitle}
              parameterTitle={parameterTitle}
              parameterValueValue={parameterValueValue}
              parameterValue={parameterValue}
              styles={styles}
              handleGetData={handleGetData}
              parameter={parameter}
              parameterImages={parameterImages}
            />
          );
        })}
        {showAllOverride ? (
          ''
        ) : (
          <>
            {parameterValues.length > parametersShowLimit && !hideAll ? (
              <div className={'text-center'}>
                {showAll ? (
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setShowAll(false);
                      setOpened(without(opened, parameterTitle));
                    }}
                  >
                    Zobraziť menej
                  </a>
                ) : (
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setShowAll(true);
                      const openParameters = openExclusive
                        ? [parameterTitle]
                        : [...opened, parameterTitle];
                      setOpened(openParameters);
                    }}
                  >
                    Zobraziť všetko
                  </a>
                )}
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CategoryElementCheckbox;
